module.exports = __webpack_public_path__ + "static/icon_as-ca618cc85f02a3e931faabffe36b3d4a.png";